/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useEffect } from "react";
import { loadWeb3, getWeb3Instance } from "./Connectivity/Connectivity";
import { toast } from "react-toastify";
import {
  USDT,
  USDTAbi,
} from "./Contract";
import "bootstrap/dist/css/bootstrap.min.css";

import { TradeXNftBurnReward, TradeXNftBurnRewardAbi} from './Contract';

export default function NftBurn() {
  const [btnTxt, setBtnTxt] = useState("Connect Wallet");
  const [account, setAccount] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const [loadingStates, setLoadingStates] = useState({});
  
  // Function inputs and outputs storage
  const [functionInputs, setFunctionInputs] = useState({});
  const [functionOutputs, setFunctionOutputs] = useState({});
  
  // Overview data
  const [rewardData, setRewardData] = useState({
    globalMarketPlaceReward: "",
    globalMatrixReward: "",
    paused: false,
    usdtBalance: "",
    userUsdtBalance: ""
  });

  // Reward contract functions definitions
  const rewardFunctions = {
    // Read Functions (View Functions)
    readFunctions: [
      {
        name: "globalMarketPlaceReward",
        title: "Global Market Place Reward",
        description: "Get the global market place reward",
        inputs: [],
        icon: "💰",
        category: "Rewards"
      },
      {
        name: "globalMatrixReward",
        title: "Global Matrix Reward",
        description: "Get the global matrix reward",
        inputs: [],
        icon: "💰",
        category: "Rewards"
      },
      {
        name: "nftMarketPlace",
        title: "NFT Market Place",
        description: "Get the NFT market place address",
        inputs: [],
        icon: "🎨",
        category: "Basic Info"
      },
      {
        name: "nftMatrix",
        title: "NFT Matrix",
        description: "Get the NFT matrix address",
        inputs: [],
        icon: "🤖",
        category: "Basic Info"
      },
      {
        name: "owner",
        title: "Owner",
        description: "Get the contract owner",
        inputs: [],
        icon: "👑",
        category: "Basic Info"
      },
      {
        name: "paused",
        title: "Paused",
        description: "Check if contract is paused",
        inputs: [],
        icon: "⏸️",
        category: "Basic Info",
        formatOutput: (value) => value ? 'Yes' : 'No'
      },
      {
        name: "usdt",
        title: "USDT",
        description: "Get the USDT address",
        inputs: [],
        icon: "💵",
        category: "Basic Info"
      }
    ],
    
    // Write Functions (Transaction Functions)
    writeFunctions: [
      {
        name: "addMarketPlaceReward",
        title: "Add Market Place Reward",
        description: "Add market place reward",
        inputs: [
          { name: "amount", type: "uint256", placeholder: "Enter amount", required: true }
        ],
        requiresApproval: true,
        icon: "➕",
        category: "Rewards"
      },
      {
        name: "addMatrixReward",
        title: "Add Matrix Reward",
        description: "Add matrix reward",
        inputs: [
          { name: "amount", type: "uint256", placeholder: "Enter amount", required: true }
        ],
        requiresApproval: true,
        icon: "➕",
        category: "Rewards"
      }
    ],

    // Admin Functions
    adminFunctions: [
      {
        name: "pause",
        title: "Pause",
        description: "Pause contract",
        inputs: [],
        icon: "⏸️",
        category: "Admin Control"
      },
      {
        name: "unpause",
        title: "Unpause",
        description: "Unpause contract",
        inputs: [],
        icon: "▶️",
        category: "Admin Control"
      },
      {
        name: "renounceOwnership",
        title: "Renounce Ownership",
        description: "Renounce ownership",
        inputs: [],
        icon: "👑",
        category: "Admin Control"
      },
      {
        name: "transferOwnership",
        title: "Transfer Ownership",
        description: "Transfer ownership",
        inputs: [
          { name: "newOwner", type: "address", placeholder: "Enter new owner", required: true }
        ],
        icon: "🔄",
        category: "Admin Control"
      },
      {
        name: "setNewNftMarketPlace",
        title: "Set New NFT Market Place",
        description: "Set new NFT market place",
        inputs: [
          { name: "newNftMarketPlace", type: "address", placeholder: "Enter new NFT market place", required: true }
        ],
        icon: "🎨",
        category: "Admin Settings"
      },
      {
        name: "setNftMatrixContract",
        title: "Set NFT Matrix Contract",
        description: "Set NFT matrix contract",
        inputs: [
          { name: "newNftMatrix", type: "address", placeholder: "Enter new NFT matrix", required: true }
        ],
        icon: "🤖",
        category: "Admin Settings"
      },
      {
        name: "setUsdt",
        title: "Set USDT",
        description: "Set USDT",
        inputs: [
          { name: "newToken", type: "address", placeholder: "Enter new token", required: true }
        ],
        icon: "💵",
        category: "Admin Settings"
      },
      {
        name: "recoverErc20",
        title: "Recover ERC20",
        description: "Recover ERC20",
        inputs: [
          { name: "erc20Token", type: "address", placeholder: "Enter ERC20 token", required: true },
          { name: "amount", type: "uint256", placeholder: "Enter amount", required: true }
        ],
        icon: "🔄",
        category: "Admin Recovery"
      },
      {
        name: "recoverErc20All",
        title: "Recover ERC20 All",
        description: "Recover all ERC20",
        inputs: [
          { name: "erc20Token", type: "address", placeholder: "Enter ERC20 token", required: true }
        ],
        icon: "🔄",
        category: "Admin Recovery"
      },
      {
        name: "recoverEth",
        title: "Recover Eth",
        description: "Recover Eth",
        inputs: [
          { name: "amount", type: "uint256", placeholder: "Enter amount", required: true }
        ],
        icon: "💎",
        category: "Admin Recovery"
      },
      {
        name: "recoverUsdt",
        title: "Recover USDT",
        description: "Recover USDT",
        inputs: [
          { name: "amount", type: "uint256", placeholder: "Enter amount", required: true }
        ],
        icon: "💵",
        category: "Admin Recovery"
      },
      {
        name: "recoverUsdtAll",
        title: "Recover USDT All",
        description: "Recover all USDT",
        inputs: [],
        icon: "💵",
        category: "Admin Recovery"
      }
    ]
  };

  const connectWallet = async () => {
    setLoadingStates(prev => ({ ...prev, connect: true }));
    
    try {
      const acc = await loadWeb3();
      if (acc === "No Wallet") {
        toast.error("No Wallet Detected");
        setBtnTxt("Connect Wallet");
      } else if (acc === "Wrong Network") {
        toast.error("Please switch to opBNB Mainnet");
        setBtnTxt("Wrong Network");
      } else {
        setAccount(acc);
        setBtnTxt(acc.substring(0, 6) + '...' + acc.substring(acc.length - 4));
        toast.success("Connected to opBNB Mainnet");
        
        loadRewardData();
      }
    } catch (error) {
      console.error("Connection error:", error);
      toast.error("Connection failed");
      setBtnTxt("Connect Wallet");
    } finally {
      setLoadingStates(prev => ({ ...prev, connect: false }));
    }
  };

  const getContract = () => {
    const web3 = getWeb3Instance();
    return new web3.eth.Contract(TradeXNftBurnRewardAbi, TradeXNftBurnReward);
  };

  const getUsdtContract = () => {
    const web3 = getWeb3Instance();
    return new web3.eth.Contract(USDTAbi, USDT);
  };

  const loadRewardData = useCallback(async () => {
    if (!account) return;
    
    try {
      const web3 = getWeb3Instance();
      const contract = getContract();
      const usdtContract = getUsdtContract();
      
      const [globalMarketPlaceReward, globalMatrixReward, paused, contractUsdtBalance, userUsdtBalance] = await Promise.all([
        contract.methods.globalMarketPlaceReward().call().catch(() => "0"),
        contract.methods.globalMatrixReward().call().catch(() => "0"),
        contract.methods.paused().call().catch(() => false),
        usdtContract.methods.balanceOf(TradeXNftReward).call().catch(() => "0"),
        usdtContract.methods.balanceOf(account).call().catch(() => "0")
      ]);

      setRewardData({
        globalMarketPlaceReward: globalMarketPlaceReward.toString(),
        globalMatrixReward: globalMatrixReward.toString(),
        paused: paused,
        usdtBalance: parseFloat(web3.utils.fromWei(contractUsdtBalance.toString(), 'mwei')).toFixed(2),
        userUsdtBalance: parseFloat(web3.utils.fromWei(userUsdtBalance.toString(), 'mwei')).toFixed(2)
      });
      
    } catch (error) {
      console.error("Error loading reward data:", error);
      toast.error("Failed to load reward data");
    }
  }, [account]);

  useEffect(() => {
    if (account) {
      loadRewardData();
    }
  }, [account, loadRewardData]);

  const handleInputChange = (functionName, inputName, value) => {
    setFunctionInputs(prev => ({
      ...prev,
      [functionName]: {
        ...prev[functionName],
        [inputName]: value
      }
    }));
  };

  const executeReadFunction = async (functionData) => {
    if (!account) {
      toast.error("Please connect your wallet first");
      return;
    }

    const funcKey = functionData.name;
    setLoadingStates(prev => ({ ...prev, [funcKey]: true }));
    try {
      const contract = getContract();
      const inputs = functionInputs[funcKey] || {};
      
      const args = functionData.inputs.map(input => {
        const value = inputs[input.name];
        if (input.required && (!value || value.trim() === '')) {
          throw new Error(`${input.name} is required`);
        }
        if (input.type.includes('[]') && typeof value === 'string') {
          return value.split(',').map(v => v.trim());
        }
        return value || '';
      });

      const result = await contract.methods[functionData.name](...args).call();
      
      const formattedResult = functionData.formatOutput 
        ? functionData.formatOutput(result)
        : JSON.stringify(result, (key, value) => typeof value === 'bigint' ? value.toString() : value, 2);

      setFunctionOutputs(prev => ({
        ...prev,
        [funcKey]: formattedResult
      }));

      toast.success("Read operation successful!");
    } catch (error) {
      console.error("Read error:", error);
      toast.error(error.message || "Read operation failed");
    } finally {
      setLoadingStates(prev => ({ ...prev, [funcKey]: false }));
    }
  };

  const executeWriteFunction = async (functionData) => {
    if (!account) {
      toast.error("Please connect your wallet first");
      return;
    }

    const funcKey = functionData.name;
    setLoadingStates(prev => ({ ...prev, [funcKey]: true }));
    try {
      const contract = getContract();
      const usdtContract = getUsdtContract();
      const inputs = functionInputs[funcKey] || {};
      
      const args = functionData.inputs.map(input => {
        const value = inputs[input.name];
        if (input.required && (!value || value.trim() === '')) {
          throw new Error(`${input.name} is required`);
        }
        if (input.type.includes('[]') && typeof value === 'string') {
          return value.split(',').map(v => v.trim());
        }
        if (input.type === 'bool') {
          return value.toLowerCase() === 'true';
        }
        return value || '';
      });

      if (functionData.requiresApproval) {
        const usdtAmount = args[0];
        const allowance = await usdtContract.methods.allowance(account, TradeXNftReward).call();
        if (BigInt(allowance) < BigInt(usdtAmount)) {
          toast.info("Approving USDT...");
          await usdtContract.methods.approve(TradeXNftReward, usdtAmount).send({
            from: account
          });
          toast.success("USDT Approved!");
        }
      }

      const tx = await contract.methods[functionData.name](...args).send({
        from: account
      });

      toast.success(`Transaction successful! Hash: ${tx.transactionHash}`);
      loadRewardData();
    } catch (error) {
      console.error("Write error:", error);
      toast.error(error.message || "Write operation failed");
    } finally {
      setLoadingStates(prev => ({ ...prev, [funcKey]: false }));
    }
  };

  const groupFunctionsByCategory = (functions) => {
    return functions.reduce((acc, func) => {
      const cat = func.category || 'Other';
      if (!acc[cat]) acc[cat] = [];
      acc[cat].push(func);
      return acc;
    }, {});
  };

  const renderFunctionCard = (func, isWrite = false, isAdmin = false) => {
    const funcKey = func.name;
    const inputs = functionInputs[funcKey] || {};
    const output = functionOutputs[funcKey];
    const isLoading = loadingStates[funcKey] || false;

    return (
      <div key={funcKey} className="col-lg-4 col-md-6 mb-4">
        <div className="card h-100 shadow-lg border-0" style={{
          borderRadius: '20px',
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02))',
          backdropFilter: 'blur(15px)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div className="card-body p-4 d-flex flex-column">
            <div className="d-flex align-items-center mb-3">
              <span className="fs-3 me-3">{func.icon}</span>
              <div>
                <h5 className="mb-1 text-white">{func.title}</h5>
                <small className="text-white-50">{func.description}</small>
              </div>
            </div>

            {func.inputs.map(input => (
              <div key={input.name} className="mb-3">
                <input
                  type="text"
                  className="form-control bg-dark border-0 text-white placeholder-white"
                  placeholder={input.placeholder}
                  value={inputs[input.name] || ''}
                  onChange={(e) => handleInputChange(funcKey, input.name, e.target.value)}
                  style={{
                    borderRadius: '12px',
                    padding: '12px'
                  }}
                />
              </div>
            ))}

            <button 
              onClick={() => isWrite || isAdmin 
                ? executeWriteFunction(func)
                : executeReadFunction(func)}
              disabled={isLoading}
              className="btn w-100 mt-auto"
              style={{
                background: isWrite || isAdmin 
                  ? 'linear-gradient(135deg, #ff6b6b, #4ecdc4)' 
                  : 'linear-gradient(135deg, #00ff88, #00ccff)',
                border: 'none',
                color: '#fff',
                borderRadius: '12px',
                padding: '12px',
                fontWeight: '600'
              }}
            >
              {isLoading ? 'Processing...' : (isWrite || isAdmin ? 'Execute Write' : 'Read')}
            </button>

            {output && (
              <div className="mt-3 p-3 rounded-3" style={{
                background: 'rgba(0, 255, 136, 0.1)',
                border: '1px solid rgba(0, 255, 136, 0.3)',
                whiteTradeX: 'pre-wrap',
                overflow: 'auto',
                maxHeight: '200px'
              }}>
                <small className="text-white-50 d-block mb-2">Output:</small>
                <code className="text-white">{output}</code>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center p-4" style={{
      background: 'linear-gradient(135deg, #000428, #004e92)'
    }}>
      <div className="container text-center">
        <h1 className="mb-5 display-4 fw-bold" style={{
          background: 'linear-gradient(135deg, #00ff88, #00ccff)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          TradeX NFT Burn Dashboard
        </h1>

        <div className="mb-5">
          <button 
            onClick={connectWallet}
            disabled={loadingStates.connect}
            className="btn px-4 px-md-5 py-3 rounded-pill shadow-lg position-relative overflow-hidden"
            style={{ 
              background: account ? 
                'linear-gradient(135deg, #00ff88, #00ccff)' : 
                'linear-gradient(135deg, #ff6b6b, #4ecdc4)',
              border: 'none',
              color: account ? '#000' : '#fff',
              fontSize: 'clamp(0.9rem, 3vw, 1.1rem)', 
              fontWeight: '700',
              transition: 'all 0.3s ease',
              minWidth: '160px',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
              opacity: loadingStates.connect ? 0.7 : 1
            }}
          >
            {loadingStates.connect ? (
              <div className="d-flex align-items-center">
                <div className="spinner-border spinner-border-sm me-2" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                Connecting...
              </div>
            ) : (
              <span className="position-relative">{btnTxt}</span>
            )}
          </button>
        </div>
        
        {account && (
          <div className="mt-4 p-3 rounded-4" style={{
            background: 'rgba(0, 255, 136, 0.1)',
            border: '1px solid rgba(0, 255, 136, 0.3)'
          }}>
            <div className="d-flex justify-content-center align-items-center gap-2">
              <span className="text-white-50 small">
                🔗 {account.substring(0, 6)}...{account.substring(account.length - 4)}
              </span>
              <span className="badge bg-success rounded-pill">Connected</span>
            </div>
          </div>
        )}

        {account && (
          <div className="row">
            <div className="col-12">
              <div className="card shadow-lg border-0 mb-4" style={{ 
                borderRadius: '24px',
                background: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.1)'
              }}>
                <div className="card-header border-0 p-4" style={{ 
                  borderRadius: '24px 24px 0 0',
                  background: 'transparent'
                }}>
                  <ul className="nav nav-pills justify-content-center flex-wrap gap-2" role="tablist">
                    {[
                      { key: 'overview', label: 'Overview', icon: '🏪', color: '#00ff88' },
                      { key: 'read', label: 'Read Functions', icon: '👁️', color: '#45b7d1' },
                      { key: 'write', label: 'Write Functions', icon: '📝', color: '#4ecdc4' },
                      { key: 'admin', label: 'Admin Functions', icon: '⚙️', color: '#ff6b6b' }
                    ].map(tab => (
                      <li key={tab.key} className="nav-item">
                        <button
                          className={`nav-link border-0 px-4 py-3 fw-bold position-relative overflow-hidden ${
                            activeTab === tab.key ? 'text-dark' : 'text-white-50'
                          }`}
                          onClick={() => setActiveTab(tab.key)}
                          style={{
                            borderRadius: '16px',
                            background: activeTab === tab.key ? 
                              `linear-gradient(135deg, ${tab.color}, ${tab.color}80)` : 
                              'rgba(255, 255, 255, 0.05)',
                            border: activeTab === tab.key ? 
                              `1px solid ${tab.color}` : 
                              '1px solid rgba(255, 255, 255, 0.1)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            transform: activeTab === tab.key ? 'translateY(-2px)' : 'translateY(0)',
                            boxShadow: activeTab === tab.key ? 
                              `0 8px 25px ${tab.color}40` : 'none'
                          }}
                        >
                          <span className="me-2 fs-5">{tab.icon}</span>
                          <span className="d-none d-md-inline">{tab.label}</span>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="card-body p-4" style={{
                  background: 'rgba(0, 0, 0, 0.2)',
                  borderRadius: '0 0 24px 24px'
                }}>
                  {/* Overview Tab */}
                  {activeTab === 'overview' && (
                    <div className="row g-4">
                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(0, 255, 136, 0.15), rgba(69, 183, 209, 0.1))',
                          border: '1px solid rgba(0, 255, 136, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">💰</div>
                            <h4 className="text-white mb-2">{rewardData.globalMarketPlaceReward || '0'}</h4>
                            <p className="text-white-50 mb-0">Market Place Reward</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(rewardFunctions.readFunctions.find(f => f.name === 'globalMarketPlaceReward'))}
                              style={{
                                background: 'rgba(0, 255, 136, 0.2)',
                                border: '1px solid #00ff88',
                                color: '#00ff88'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(69, 183, 209, 0.15), rgba(107, 224, 215, 0.1))',
                          border: '1px solid rgba(69, 183, 209, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">💰</div>
                            <h4 className="text-white mb-2">{rewardData.globalMatrixReward || '0'}</h4>
                            <p className="text-white-50 mb-0">Matrix Reward</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(rewardFunctions.readFunctions.find(f => f.name === 'globalMatrixReward'))}
                              style={{
                                background: 'rgba(69, 183, 209, 0.2)',
                                border: '1px solid #45b7d1',
                                color: '#45b7d1'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: `linear-gradient(135deg, ${rewardData.paused ? 'rgba(255, 107, 107, 0.15)' : 'rgba(0, 255, 136, 0.15)'}, rgba(255, 170, 0, 0.1))`,
                          border: `1px solid ${rewardData.paused ? 'rgba(255, 107, 107, 0.3)' : 'rgba(0, 255, 136, 0.3)'}`,
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">{rewardData.paused ? '⏸️' : '▶️'}</div>
                            <h4 className="text-white mb-2">
                              {rewardData.paused ? 'PAUSED' : 'ACTIVE'}
                            </h4>
                            <p className="text-white-50 mb-0">Contract Status</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(rewardFunctions.readFunctions.find(f => f.name === 'paused'))}
                              style={{
                                background: rewardData.paused ? 
                                  'rgba(255, 107, 107, 0.2)' : 'rgba(0, 255, 136, 0.2)',
                                border: rewardData.paused ? 
                                  '1px solid #ff6b6b' : '1px solid #00ff88',
                                color: rewardData.paused ? '#ff6b6b' : '#00ff88'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(255, 170, 0, 0.15), rgba(255, 107, 107, 0.1))',
                          border: '1px solid rgba(255, 170, 0, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">💰</div>
                            <h4 className="text-white mb-2">{rewardData.usdtBalance || '0.00'} USDT</h4>
                            <p className="text-white-50 mb-0">Contract Balance</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={loadRewardData}
                              style={{
                                background: 'rgba(255, 170, 0, 0.2)',
                                border: '1px solid #ffaa00',
                                color: '#ffaa00'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(0, 255, 136, 0.15), rgba(69, 183, 209, 0.1))',
                          border: '1px solid rgba(0, 255, 136, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">💼</div>
                            <h4 className="text-white mb-2">{rewardData.userUsdtBalance || '0.00'} USDT</h4>
                            <p className="text-white-50 mb-0">Your Balance</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={loadRewardData}
                              style={{
                                background: 'rgba(0, 255, 136, 0.2)',
                                border: '1px solid #00ff88',
                                color: '#00ff88'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Read Functions Tab */}
                  {activeTab === 'read' && (
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className="mb-0 text-info">👁️ Read Functions</h4>
                        <small className="text-white-50">
                          {rewardFunctions.readFunctions.length} functions available
                        </small>
                      </div>
                      {Object.entries(groupFunctionsByCategory(rewardFunctions.readFunctions)).map(([category, funcs]) => (
                        <div key={category} className="mb-5">
                          <h5 className="mb-3 text-white-50 d-flex align-items-center">
                            <span className="me-2">{category}</span>
                            <span className="badge bg-secondary rounded-pill">{funcs.length}</span>
                          </h5>
                          <div className="row">
                            {funcs.map(func => renderFunctionCard(func, false, false))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Write Functions Tab */}
                  {activeTab === 'write' && (
                    <div>
                      <h4 className="mb-4" style={{color: '#4ecdc4'}}>📝 Write Functions</h4>
                      {Object.entries(groupFunctionsByCategory(rewardFunctions.writeFunctions)).map(([category, funcs]) => (
                        <div key={category} className="mb-5">
                          <h5 className="mb-3 text-white-50">{category}</h5>
                          <div className="row">
                            {funcs.map(func => renderFunctionCard(func, true, false))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Admin Functions Tab */}
                  {activeTab === 'admin' && (
                    <div>
                      <h4 className="mb-4 text-danger">⚙️ Admin Functions</h4>
                      <div className="alert alert-warning">
                        <strong>⚠️ Warning:</strong> These functions are restricted to contract owner/admin only.
                      </div>
                      {Object.entries(groupFunctionsByCategory(rewardFunctions.adminFunctions)).map(([category, funcs]) => (
                        <div key={category} className="mb-5">
                          <h5 className="mb-3 text-white-50">{category}</h5>
                          <div className="row">
                            {funcs.map(func => renderFunctionCard(func, true, true))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}